export default __webpack_public_path__ + "002f4998d9b81a0951a9284cbfff1a25.png";